// src/data/gamesData.js
const games = [
  {
    id: "cast-ashore",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6828573087",
    title: "How to Escape Fish Island",
    shortTitle: "Fish Island",
    subtitle: "Adventure Rich Fishing Game",
    seoTitle: "How to Escape Fish Island App",
    seoDescription: "Adventure Rich Fishing Game",
    keywords: ["How to Escape Fish Island", "How to Escape Fish Island App", "Fish Island", "Fish Island App"],
    description: "Washed up on a tiny island with nothing but a fishing rod? Catch fish, chop palms, craft your gear and build a boat. Then sail the Ember Isles, beat the giant sea bosses and find your way home. Play with touch or pick up your game controller.\n\nFISH LIKE A PRO\n• Cast, wait for the bite, set the hook and fight every fish on a line that can snap\n• Each species fights its own way: darters, runners, deep divers and zigzaggers\n• From tiny sprats and reef parrotfish to tuna, wahoo and giant marlins\n• Hunt three legendary fish, each hiding in its own waters\n• Swap lures and find the right one for every spot\n\nBATTLE GIANT SEA BOSSES\n• 10 bosses, from the Grouper King and the Kraken to the mighty Leviathan\n• Every boss fights differently: dodge its attacks, aim your harpoon or bow and strike back\n• Take on the Crab King on land with sword, bow and harpoon\n• Beaten bosses drop trophies to sell or craft into better gear\n\nCHOP, CRAFT AND BUILD\n• Chop palms for logs and turn them into a bow, tools and a raft\n• Upgrade your axe, sword, harpoon, bow and speargun\n• Decorate your camp and make the island your own\n\nSAIL TO 20 ISLANDS\n• Paddle a raft, then row, then motor across the open sea in bigger boats\n• Explore volcano peaks, frozen cliffs, red canyons, temple ruins and shipwreck reefs\n• Dive for treasure: reefs, giant clams and buried chests\n• Meet the island folk and help them as Mount Ember wakes up\n\nTRADE WITH CAPTAIN CRABBY\n• Sell your catch and trophies to a grumpy crab merchant\n• Spend your coins on lures, bait, arrows and boat upgrades\n• Daily goals and a seasonal Tide Pass full of rewards\n\nPLAY WITH A CONTROLLER\n• Full external controller support: Xbox, PlayStation and MFi controllers\n• Move, cast, reel, fight and sail with sticks, triggers and buttons\n• On-screen hints…",
    features: [
      "Cast, wait for the bite, set the hook and fight every fish on a line that can snap",
      "Each species fights its own way: darters, runners, deep divers and zigzaggers",
      "From tiny sprats and reef parrotfish to tuna, wahoo and giant marlins",
      "Hunt three legendary fish, each hiding in its own waters",
      "Swap lures and find the right one for every spot",
      "10 bosses, from the Grouper King and the Kraken to the mighty Leviathan",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d1/44/2c/d1442c5f-a1ca-291b-ef60-c9470687a892/AppIcon-0-0-1x_U007epad-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6828573087",
    playStoreUrl: null,
  },
  {
    id: "digit-forge",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Digit Force: Math Roguelike",
    shortTitle: "Digit Force",
    subtitle: "Calculate it to win",
    seoTitle: "Digit Force: Math Roguelike App",
    seoDescription: "Calculate it to win",
    keywords: [
      "Digit Force: Math Roguelike",
      "Digit Force: Roguelike Puzzle",
      "Digit Force: Math Roguelike App",
      "Digit Force",
      "Digit Force App",
      "Math Roguelike",
      "Math Roguelike App",
    ],
    description: "Build a calculator nobody else has, then use it to hit the target number before your presses run out.\n\nDigit Force is a short, touch-first roguelike puzzle. Every run starts with a few simple keys. Between floors you buy stranger ones, stack passive chips and shape a keypad that turns any start value into the exact target.\n\nHOW A RUN WORKS\n• Each floor shows a start value, a target and a press limit\n• Every key press changes the display and costs one press\n• Hit the target exactly to clear the floor\n• Unused presses and key charges turn into coins for the shop\n\nFORGE YOUR KEYPAD\n• Odd keys like x2, Square, Reverse, Mirror, Append 1 and Sum Digits\n• Charged keys like Undo, Copy and Store/Recall\n• Passive chips such as Overclock, Echo, Thrift and Safety Net\n• Nine keypad slots - choose what stays and what gets replaced\n\nBEAT THE BOSSES\n• Boss floors bend the rules: jammed keys, rounding displays, ticking press limits\n• Win to unlock new keys and chips for future runs\n\nQUICK AND FAIR\n• A full run takes about 6 to 10 minutes and saves after every floor\n• Every floor is checked by a solver, so it can always be beaten\n• Plays fully offline\n\nDIGIT FORCE PRO\n• All key sets and passive chips\n• Endless mode - see how deep your build can go\n• Daily seed - the same run for everyone each day\n\nPro options: Yearly ($4.99/year) with a 3-day free trial, or Lifetime ($14.99, one-time purchase). Payment is charged to your account at confirmation of purchase (after the free trial, if any). The yearly subscription renews automatically unless cancelled at least 24 hours before the end of the current period. Manage or cancel anytime in your account settings.",
    features: [
      "Each floor shows a start value, a target and a press limit",
      "Every key press changes the display and costs one press",
      "Hit the target exactly to clear the floor",
      "Unused presses and key charges turn into coins for the shop",
      "Odd keys like x2, Square, Reverse, Mirror, Append 1 and Sum Digits",
      "Charged keys like Undo, Copy and Store/Recall",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/siMNVBkaoy7tLEn0-YF9DOHMOXLIk9uwpxWGh_nkzfgooaUXuY3fBIvRgyR7QSVD2NHQOjlZvfi-HjtJTqtS=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.digitforge",
  },
  {
    id: "felt-deal",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "The Folding Solitaire",
    shortTitle: "Solitaire",
    subtitle: "Made for iPhone Duo",
    seoTitle: "The Folding Solitaire App",
    seoDescription: "Made for iPhone Duo",
    keywords: [
      "The Folding Solitaire",
      "Solitaire: Klondike Card Game",
      "The Folding Solitaire App",
      "Solitaire",
      "Solitaire App",
    ],
    description: "Classic Klondike solitaire, beautifully dealt. Tap a card and it flies home, or drag it exactly where you want - every move is smooth, satisfying and easy to read.\n\nPlay a fresh Daily Challenge, collect crowns on your calendar, level up with every win and unlock achievements as you go. No account, no social casino - just you and the cards.\n\nWHY YOU WILL LOVE IT\n• Tap-to-play or drag and drop - cards spring into place with smooth animation\n• Draw 1 for a relaxed game or Draw 3 for a real challenge\n• Daily Challenge: the same deal for every player each day, with crowns, day streaks and monthly trophies\n• Levels and XP with bonuses for speed, win streaks, daily wins and Draw 3\n• 12 achievements to unlock, from First Clear to Grand Master\n• Combos, sparkles and the classic bouncing-card victory celebration\n• Living scenic tables: classic green felt, Moss Glade fireflies, Sunset Ridge, Midnight Lake stars, Golden Autumn leaves and Arctic Dawn aurora\n• Crisp card faces with large, clear ranks, plus four card back designs\n• Smart hints that light up your next move, undo, and one-tap auto finish\n• Replay any deal with the same shuffle\n• Left-handed layout and haptic feedback options\n• Your stats on device: wins, win rate, best time, streaks and average moves\n• Plays offline - no account required\n\nSOLITAIRE PRO\n• Every scenic table and card back\n• Unlimited hints and undos\n• Play without ads\n\nFree play includes full Klondike, the Daily Challenge, two tables, the classic card back, 3 hints and 5 undos per deal. Free players may see ads, including after a finished deal.\n\nOne-time purchases: Remove Ads $9.99, Scenic Tables $2.99, Card Backs $1.99, Starter Bundle $0.99.\n\nSubscription terms: Annual plan with a 7-day free trial, then $14.99 per year. Weekly plan $1.99 per week, no…",
    features: [
      "Tap-to-play or drag and drop - cards spring into place with smooth animation",
      "Draw 1 for a relaxed game or Draw 3 for a real challenge",
      "Daily Challenge: the same deal for every player each day, with crowns, day streaks and monthly trophies",
      "Levels and XP with bonuses for speed, win streaks, daily wins and Draw 3",
      "12 achievements to unlock, from First Clear to Grand Master",
      "Combos, sparkles and the classic bouncing-card victory celebration",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/B1dKWgH4DQ1IDynZ-Au7hk63VNATUm0Lg5gVu1D3oxnDfdXHsXPVsnRcDbaBnMtAhvXc6RSD_grp55j17Wcz8g=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.feltdeal",
  },
  {
    id: "tint-cell",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Color by Number: Coloring Game",
    shortTitle: "Color by Number",
    subtitle: "Pixel art coloring games",
    seoTitle: "Color by Number: Coloring Game App",
    seoDescription: "Pixel art coloring games",
    keywords: [
      "Color by Number: Coloring Game",
      "Color by Number: Coloring Game App",
      "Color by Number",
      "Color by Number App",
      "Coloring Game",
      "Coloring Game App",
    ],
    description: "Color by Number is calm pixel-art coloring for your phone: tap a numbered swatch, fill the matching cells, and watch a pixel picture come to life. No account, no internet needed, and never an ad while you paint.\n\nWHAT YOU GET\n• 1,000+ pixel pictures across 10 books: Birds, Cars, Cats, Dinosaurs, Dogs, Fish, Flowers, Fruit, Sweets, and Vegetables\n• Pinch-zoom canvas with numbered cells - drag a finger to fill whole rows at once\n• A new Daily picture every day, picked from the full library and free to color on its day\n• Boosters while you color: Wand fills every cell of a color, Splash fills a small patch, Finder shows where the next cells are\n• Tap to Replay: watch your finished picture paint itself again\n• My Works keeps your in-progress and finished pictures\n• Progress saves on your device - pick up any picture where you left off\n\nFREE TO PLAY\nFree players get about 75 free pictures, including the first page of every book, the Daily picture, and free boosters every day (3 Wand, 2 Splash, 3 Finder). Out of boosters? Choose to watch a short video for a refill once a day. The free version shows a banner on the gallery screens and may show an ad after you finish a picture - never while you paint.\n\nPRO UNLOCKS\n• All 10 books and every picture\n• Unlimited boosters\n• No ads",
    features: [
      "1,000+ pixel pictures across 10 books: Birds, Cars, Cats, Dinosaurs, Dogs, Fish, Flowers, Fruit, Sweets, and Vegetables",
      "Pinch-zoom canvas with numbered cells - drag a finger to fill whole rows at once",
      "A new Daily picture every day, picked from the full library and free to color on its day",
      "Boosters while you color: Wand fills every cell of a color, Splash fills a small patch, Finder shows where the next cells are",
      "Tap to Replay: watch your finished picture paint itself again",
      "My Works keeps your in-progress and finished pictures",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/hip-CZnozSztz8s4HIcz54WVwZHrZXZ6CX83YfhdOP_bil9IvU9APZbZFZ4zn9ccr4OVR2Qes9y3GwpRMGDx3_E=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.tintcell",
  },
  {
    id: "dub-score",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Dubuno - Voiceover & Dubbing",
    shortTitle: "Dubuno",
    subtitle: "The Voicer Choicer App",
    seoTitle: "Dubuno - Voiceover & Dubbing App",
    seoDescription: "The Voicer Choicer App",
    keywords: ["Dubuno - Voiceover & Dubbing", "Dubuno", "Dubuno - Voiceover & Dubbing App", "Dubuno App"],
    description: "Karaoke apps want accounts and licensed songs. Solo performers still want to dub a scene, and hear the reference without setting up a party roster.\n\nDubuno is a solo scene-dubbing studio. Import a short clip from your camera roll or try a bundled practice scene, listen to the reference with captions, record your take, and get timing, energy plus a director note.\n\nWHAT YOU GET\n• Import from Photos and trim to the line\n• Bundled practice clips you can try immediately\n• Listen to the reference, then dub with timed captions\n• Fair, Strict, or Chaotic judge comments with timing, energy, and delivery bars\n• Retry any take on this device\n• 100% on-device - audio and imported clips never leave the phone, no account\n\nDUB PRO UNLOCKS\n• 3-minute clips (free imports cap at 1 minute)\n• Dub Export - save your dubbed scene to Photos\n• Ad-free takes\n\nFree players may see an interstitial between takes (never during listen or record) and during longer imports. You supply the media. Optional bundled scenes use U.S. public-domain film clips, not modern studio movies.",
    features: [
      "Import from Photos and trim to the line",
      "Bundled practice clips you can try immediately",
      "Listen to the reference, then dub with timed captions",
      "Fair, Strict, or Chaotic judge comments with timing, energy, and delivery bars",
      "Retry any take on this device",
      "100% on-device - audio and imported clips never leave the phone, no account",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/Q-p4gRFI7XZll5BoUAe2uAXVbPjyzf4F9OeqDVJx9J-MZsWRZIkIl7maOD-ofrvIlaJ3oYlQYGBaObWEG3uRqX8=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.dubscore",
  },
  {
    id: "mic-pad",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Soundboard Maker - Mic Pad",
    shortTitle: "Mic Pad",
    subtitle: "Record pads and funny boards",
    seoTitle: "Soundboard Maker - Mic Pad App",
    seoDescription: "Record pads and funny boards",
    keywords: [
      "Soundboard Maker - Mic Pad",
      "Mic Pad: Soundboard Maker",
      "Soundboard Maker - Mic Pad App",
      "Mic Pad",
      "Mic Pad App",
    ],
    description: "Meme soundboards spam an ad on every tap and bury record-your-own pads behind broken libraries. Friends just want a clean board they can mash at parties.\n\nMic Pad lets you hold to record a voice drop or sound, drop it on a bright pad, and play a grid offline - no account, no cloud library wall.\n\nWHAT YOU GET\n• Hold-to-record pads (up to 6 seconds) saved on this device\n• Free 2x2 board for your own clips - mash anytime offline\n• Original Reactions and Party comedy packs (procedural tones - family-safe first)\n• Assign pack sounds onto empty pads and remix your board\n• Dark stage UI with orange pad energy - built for quick party taps\n• No account required - pads stay on your phone\n\nPAD PRO UNLOCKS\n• Sound packs (Reactions + Party)\n• Bigger 3x3 boards\n• Ad-free taps\n\nFree players can watch a short video to unlock one pack for 24 hours. Free users may see an interstitial about every 4 pad taps (never more often than once every 120 seconds). Core record + 2x2 play works without purchase.",
    features: [
      "Hold-to-record pads (up to 6 seconds) saved on this device",
      "Free 2x2 board for your own clips - mash anytime offline",
      "Original Reactions and Party comedy packs (procedural tones - family-safe first)",
      "Assign pack sounds onto empty pads and remix your board",
      "Dark stage UI with orange pad energy - built for quick party taps",
      "No account required - pads stay on your phone",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/YJCesyTr_JE2tdJhyDrKTKMWdRQjQby44ssOEO0N77W3jmzLWec5YbhyZaJfXfsxq5P1g6kt7iU8mYZNo__Yb9c=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.micpad",
  },
  {
    id: "wod-face",
    categoryKey: "cat_party",
    downloads: "",
    apple_id: null,
    title: "HIIT Timer - Wod Face",
    shortTitle: "Wod Face",
    subtitle: "Tabata EMOM interval clock",
    seoTitle: "HIIT Timer - Wod Face App",
    seoDescription: "Tabata EMOM interval clock",
    keywords: [
      "HIIT Timer - Wod Face",
      "Wod Face: HIIT Timer",
      "HIIT Timer - Wod Face App",
      "Wod Face",
      "Wod Face App",
    ],
    description: "Tired of HIIT timers that lock the next round behind a paywall after one free workout - or bury Tabata and EMOM under blank interval math?\n\nWod Face puts named presets first. Tap Tabata, EMOM, AMRAP, or Classic HIIT, then run a giant face clock with clear work and rest colors, haptics, and beeps you can see from the mat. No account.\n\nWHAT YOU GET\n• Named core presets that always run - Tabata, EMOM, AMRAP 10, Classic HIIT\n• Fullscreen work / rest face clock with prepare countdown\n• Beep, Whistle, and Bell cues in Settings\n• Athlete pack (Boxing Rounds, Fight Camp, AMRAP 20, Death By) via Pro or a short rewarded unlock (24h)\n• Session counter on device - no cloud sync required\n\nWOD PRO UNLOCKS\n• Athlete preset pack\n• Ad-free sessions\n\nFree users may see an interstitial about every 2 completed sessions. Core presets always work without purchase.",
    features: [
      "Named core presets that always run - Tabata, EMOM, AMRAP 10, Classic HIIT",
      "Fullscreen work / rest face clock with prepare countdown",
      "Beep, Whistle, and Bell cues in Settings",
      "Athlete pack (Boxing Rounds, Fight Camp, AMRAP 20, Death By) via Pro or a short rewarded unlock (24h)",
      "Session counter on device - no cloud sync required",
      "Athlete preset pack",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/Dblgr5LRjYf_Jb2BKj39-OatS6p-MnqO-piwhX7wUBe0lON_rCp3gKi8sPKHYergIqC-jrevsl9eyaVYJ2XcHxM=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.wodface",
  },
  {
    id: "decks",
    categoryKey: "cat_education",
    downloads: "",
    apple_id: "6812365870",
    title: "Decks: Study Flashcards",
    shortTitle: "Decks",
    subtitle: "Tap a pack. Flip to study.",
    seoTitle: "Decks: Study Flashcards App",
    seoDescription: "Tap a pack. Flip to study.",
    keywords: [
      "Decks: Study Flashcards",
      "Decks: Study Flashcards App",
      "Decks",
      "Decks App",
      "Study Flashcards",
      "Study Flashcards App",
    ],
    description: "Want ready flashcard packs you can open and study now — without accounts, AI popups, or building every card first?\n\nDecks gives you Explore packs for languages, school, skills, and more. Tap a deck, flip through cards, and mark Know or Miss. Prefer your own content? Build Custom decks on your phone.\n\nWHAT YOU GET\n• Ready Explore packs across popular study topics\n• Flip study with Know / Miss feedback\n• Daily study streak tracked on device\n• Custom decks for your own cards\n• Up to 3 custom decks and 5 cards per deck free — unlock more with Decks Pro\n• Free Flip study mode; Misses only and Shuffle unlock with Pro or a short rewarded ad (24h)\n• No account and no cloud sync required\n\nDECKS PRO UNLOCKS\n• Study modes (Misses only, Shuffle)\n• Unlimited custom decks and cards\n• Ad-free drills\n\nFree users may see an interstitial about every 10 study cards. Core Flip study works without purchase.",
    features: [
      "Ready Explore packs across popular study topics",
      "Flip study with Know / Miss feedback",
      "Daily study streak tracked on device",
      "Custom decks for your own cards",
      "Up to 3 custom decks and 5 cards per deck free — unlock more with Decks Pro",
      "Free Flip study mode; Misses only and Shuffle unlock with Pro or a short rewarded ad (24h)",
    ],
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/VZ9MhHwwMZzkT055puO6D2OACZiS-f4Q9-uZXcZ7ioonJ7xnx_hv8LQcckwctd3mez2i3dN6-qaZflwdKuKLuN4=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6812365870",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.snapdeck",
  },
  {
    id: "flip-verse",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Flip Verse: Reverse Singing",
    shortTitle: "Flip Verse",
    subtitle: "Record, reverse & share",
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/ypfOPiJZfVLgQsMn4ys2LFVRVF3ZKXagHYWOezIoPX2HgmZOOdgeBZV7h_eyJPbXiOVURb1xUzSmL_qQS-HzdA=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.flipverse",
  },
  {
    id: "room-act",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: null,
    title: "Room Act: Party Charades",
    shortTitle: "Room Act",
    subtitle: "Act it out · friends guess",
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/Vextq85GgjcTE1k3FBuuyHCp1tJ4wNQrrYUKWrag1tGdFGO15wLImU4BAxtG6NpCn19UqjkZvI_fSFQWgBTAbQ=w512-h512",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.roomact",
  },
  {
    id: "tangens",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6810116809",
    title: "Tangens: UV Index, Tan Timer",
    shortTitle: "Tangens",
    subtitle: "Plan safer outdoor sun time",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5b/48/67/5b4867cf-36a7-003b-5e36-7abfb7bab514/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6810116809",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.sunwindow",
  },
  {
    id: "voice-judge",
    categoryKey: "cat_party",
    downloads: "",
    apple_id: "6801482202",
    title: "Voice Judge: Dub Scenes",
    shortTitle: "Voice Judge",
    subtitle: "Dub scenes with friends and compete for the best performance",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b7/ac/c1/b7acc115-0c5f-6eeb-34db-a2e71043661c/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6801482202",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.voicejudge",
  },
  {
    id: "driving-theory",
    categoryKey: "cat_education",
    downloads: "",
    apple_id: "6800224243",
    title: "Driving Theory Test 2026",
    shortTitle: "Theory Test",
    subtitle: "Practice driving theory and Life in the UK test questions",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f1/0f/88/f10f8826-853b-8616-1887-b5cd6b6155cb/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6800224243",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.theory",
  },
  {
    id: "migraine-tracker",
    categoryKey: "cat_health",
    downloads: "",
    apple_id: "6799493907",
    title: "Migraine & Headache AI Tracker",
    shortTitle: "Migraine Tracker",
    subtitle: "Private migraine and headache attack tracker with AI insights",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/85/d5/4f/85d54feb-65db-c21f-dfcf-36ffeaa2cb4e/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6799493907",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.migrainelog",
  },
  {
    id: "pass-photo",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6801896727",
    title: "Pass Photo: Passport ID Size",
    shortTitle: "Pass Photo",
    subtitle: "Crop passport and ID photos to official size with print sheets",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/43/a0/26/43a026bc-dac8-7bd6-92f1-b0fe4b4ea0d8/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6801896727",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.passphoto",
  },
  {
    id: "code-snap",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6797888829",
    title: "Code Snap: QR Generator",
    shortTitle: "Code Snap",
    subtitle: "Wi-Fi, URL & contact codes",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/00/89/dd/0089ddc0-ebd5-54f9-b37d-7a4a85f6218d/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6797888829",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.codesnap",
  },
  {
    id: "level-snap",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6799092631",
    title: "Level Snap: Bubble Level",
    shortTitle: "Level Snap",
    subtitle: "Bubble level tool for hanging pictures and shelves straight",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/01/37/4e/01374ea3-dc45-b6ff-36e0-d4c1e086cd5c/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6799092631",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.levelsnap",
  },
  {
    id: "eretz-ir",
    categoryKey: "cat_trivia",
    downloads: "",
    apple_id: "6763717588",
    title: "ארץ עיר 2026",
    shortTitle: "ארץ עיר",
    subtitle: "המשחק הקלאסי בנייר — עכשיו על הסמארטפון",
    countryCode: "il",
    direction: "rtl",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/32/b1/4c/32b14cf3-31b3-06f5-38ee-f88db69c5f56/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6763717588",
    playStoreUrl: "https://play.google.com/store/apps/details?id=tomerrubin.com.categories",
  },
  {
    id: "dusty",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6759482584",
    title: "AI Storage Cleaner: Dusty",
    shortTitle: "Dusty",
    subtitle: "AI storage cleaner that finds duplicates and frees up space",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a4/17/e0/a417e081-55eb-0ade-3ab9-f80048436d1d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6759482584",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.dusty",
  },
  {
    id: "pups",
    categoryKey: "cat_health",
    downloads: "",
    apple_id: "6758136553",
    title: "Pups: Daily Routine & Habits",
    shortTitle: "Pups",
    subtitle: "Daily routines and habits for kids",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/69/3c/2a/693c2af0-e01b-d11a-f48b-32ab185a8a54/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6758136553",
    playStoreUrl: null,
  },
  {
    id: "blackjack",
    categoryKey: "cat_casino",
    downloads: "",
    apple_id: null,
    title: "Blackjack 3D: 21 Casino Game",
    shortTitle: "Blackjack 3D",
    subtitle: "Classic 21 blackjack in immersive 3D",
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/eA-5X6OBVYwGRUCqsroVR1RZo6EPhFuFY69p4Pzrf0oqiRSQ5xwg-SDkEONVGrWjXbMcEnghwQ8S6Rs6jx_YFQ=s0-br30",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.blackjack",
  },
  {
    id: "poker",
    categoryKey: "cat_casino",
    downloads: "",
    apple_id: null,
    title: "Poker 3D: Casino Game",
    shortTitle: "Poker 3D",
    subtitle: "Texas hold'em poker in immersive 3D",
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/diRsCOZlL2dRcxhHhPkh4xMI6-bCq7KEyCilSwL4RJpl9qFYn23dPjpzTl77RJdSwnkS2-NwYWu0VJOas14=s0-br30",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.poker",
  },
  {
    id: "cue-scroll",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6807175763",
    title: "Cue Scroll: Teleprompter",
    shortTitle: "Cue Scroll",
    subtitle: "Read a script on camera",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a0/cd/7a/a0cd7afe-3493-77c7-bd41-d5a11cc9be68/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6807175763",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.cuescroll",
  },
  {
    id: "stud-peak",
    categoryKey: "cat_utility",
    downloads: "",
    apple_id: "6806526202",
    title: "Stud Peak: Wall Stud Finder",
    shortTitle: "Stud Peak",
    subtitle: "Live microtesla scan",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/20/9c/00/209c00f9-3259-2cd0-d98c-120b076192c2/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/512x512bb.jpg",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: "https://apps.apple.com/app/id6806526202",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.studpeak",
  },
  {
    id: "flag-quiz",
    categoryKey: "cat_game",
    downloads: "",
    apple_id: null,
    title: "Flag Quiz: Country Trivia",
    shortTitle: "Flag Quiz",
    subtitle: "Guess countries from their flags",
    countryCode: "us",
    direction: "ltr",
    icon: "https://play-lh.googleusercontent.com/AMfJoDdlp_9LK5iQALSNUuOr0L1SFHZnOmBelqb15QB_rGKAfKJDah2Uvj-jE7VVhd3tQo9mAYlxKVlYIdEg7g=s0-br30",
    slideIcon: null,
    slideBackground: null,
    video: null,
    appStoreUrl: null,
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.mindblows.flagquiz",
  },
  {
    id: "volcano",
    categoryKey: "cat_game",
    downloads: "50K",
    apple_id: "1487844789",
    title: "Volcano - Tropical Word Game",
    shortTitle: "Volcano",
    subtitle: "Tropical word search puzzles in English and Hebrew",
    countryCode: "il",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/c8/3a/46/c83a4677-3188-0247-f2a7-4dbd5477d3c8/AppIcon-0-0-1x_U007epad-0-1-0-0-85-220.png/512x512bb.jpg",
    slideIcon: "icon1",
    slideBackground: "slide1",
    video: "https://www.youtube.com/embed/0ugV2qPGlqg",
    appStoreUrl: "https://apps.apple.com/app/id1487844789",
    playStoreUrl: "https://play.google.com/store/apps/details?id=tomerrubin.com.volcano",
  },
  {
    id: "sucaryot",
    categoryKey: "cat_game",
    downloads: "1.2M",
    apple_id: "1298407883",
    title: "סוכריות - תשחץ מהעתיד",
    shortTitle: "סוכריות",
    subtitle: "תשחץ מהעתיד — אלפי תשבצים בעברית",
    countryCode: "il",
    direction: "rtl",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/dc/05/05/dc05056c-64d4-e3b4-ff26-f3e721d8b29e/AppIcon-0-0-1x_U007epad-0-1-0-0-85-220.png/512x512bb.jpg",
    slideIcon: "icon2",
    slideBackground: "slide2",
    video: "https://www.youtube.com/embed/kYI1Qt4hxg8",
    appStoreUrl: "https://apps.apple.com/app/id1298407883",
    playStoreUrl: "https://play.google.com/store/apps/details?id=tomerrubin.com.wordcandy",
  },
  {
    id: "tricky-quiz",
    categoryKey: "cat_game",
    downloads: "250K",
    apple_id: "1423711679",
    title: "המבחן - בואו להיות גאונים",
    shortTitle: "המבחן",
    subtitle: "חידות מאתגרות שיבדקו כמה אתם באמת חכמים",
    countryCode: "il",
    direction: "rtl",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/26/22/9d/26229d5a-b938-deb2-634a-28cd30573131/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/512x512bb.jpg",
    slideIcon: "icon3",
    slideBackground: "slide3",
    video: "https://www.youtube.com/embed/K5hvR_CRz30",
    appStoreUrl: "https://apps.apple.com/app/id1423711679",
    playStoreUrl: "https://play.google.com/store/apps/details?id=tomerrubin.com.thetestgame",
  },
  {
    id: "sucaryot-kids",
    categoryKey: "cat_game",
    downloads: "20K",
    apple_id: "1278974252",
    title: "סוכריות קידס",
    shortTitle: "סוכריות קידס",
    subtitle: "גרסת ילדים של משחק סוכריות",
    countryCode: "il",
    direction: "rtl",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/6a/51/f5/6a51f536-fa34-8349-3b1b-502c07644a23/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/512x512bb.jpg",
    slideIcon: "icon4",
    slideBackground: "slide4",
    video: "https://www.youtube.com/embed/ZsFvOPMjVHg",
    appStoreUrl: "https://apps.apple.com/app/id1278974252",
    playStoreUrl: null,
  },
  {
    id: "truth-or-dare-2",
    categoryKey: "cat_game",
    downloads: "500K",
    apple_id: "1241647692",
    title: "Truth or Dare 2",
    shortTitle: "Truth or Dare 2",
    subtitle: "The ultimate party game for friends",
    countryCode: "us",
    direction: "ltr",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/66/85/99/668599de-258f-a756-b348-c999881efb18/AppIcon-0-0-1x_U007emarketing-0-11-0-0-85-220.png/512x512bb.jpg",
    slideIcon: "icon5",
    slideBackground: "slide5",
    video: "https://www.youtube.com/embed/8mHyuDp3A1M",
    appStoreUrl: "https://apps.apple.com/app/id1241647692",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.tomerrubin.truthordare",
  },
];

export const featuredAppIds = [
  "tangens",
  "cue-scroll",
  "stud-peak",
  "voice-judge",
  "driving-theory",
  "pass-photo",
  "code-snap",
  "migraine-tracker",
];

export default games;
